import { useMemo } from 'react';

export const getInstitutionSubdomain = (host: string): string | null => {
  const parts = host.split(/[.:]/u);

  const isNgrok = window.location.origin.includes('ngrok.io');
  const isEphemeral = window.location.origin.includes('doxy-ephemeral.me');
  if (isNgrok) {
    return null;
  }

  if (isEphemeral && parts[0]) {
    // Parse clinic name from format: clinic--core-1234
    // Use lastIndexOf to find the separator between clinic and MR reference
    // This handles clinic names that contain double dashes
    const lastDoubleDashIndex = parts[0].lastIndexOf('--');
    if (lastDoubleDashIndex > 0) {
      // Extract clinic name before the last double dash
      return parts[0].slice(0, lastDoubleDashIndex);
    }
    // Return null for ephemeral domains without the clinic--core format
    return null;
  }

  // Return null for domains without subdomains
  return parts.length === 3 ? parts[0] ?? null : null;
};

export const useInstitutionSubdomain = (): string | null => {
  return useMemo(() => getInstitutionSubdomain(window.location.host), []);
};
